/* eslint-disable react-hooks/exhaustive-deps */
import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import CalendarField from "@components/atoms/date-picker/datePicker.atom";
import FormWrapper from "@components/atoms/formWrapper/formWrapper.atom";
import TextField from "@components/atoms/input";
import { homeActions } from "@components/features/home/home.slice";
import { profileActions } from "@components/features/profile/profile.slice";
import { BodyProps } from "@components/features/profile/profile.type";
import Layout from "@components/molecules/layout";
import theme from "@config/theme";
import dayjs, { Dayjs } from "dayjs";
import { useFormik } from "formik";
import { useEffect } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import * as Yup from "yup";

import { LoaderSnackbarWrapperActions } from "../LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import {
  Container,
  Content,
  LogoWrapper,
  SubTitle,
  Title,
  TitleWrapper,
  Wrapper,
} from "./signUp.styled";
import { SignUpProps } from "./signUp.type";

import { ReactComponent as Logo } from "@assets/images/logo/logos.svg";

type ReduxProps = ConnectedProps<typeof connector>;

const SignUp = ({
  authState,
  updateUser,
  setLoader,
  setAlert,
  setContentRender,
  setUser,
}: SignUpProps & ReduxProps) => {
  const user = useSelector((state: RootState) => state?.user?.user);
  const currentUser = localStorage.getItem("currentUser");

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      dob: null,
      email: user.email,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Required"),
      lastName: Yup.string().required("Required"),
      dob: Yup.string().required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
    }),
    onSubmit: () => {},
  });

  const handleDateChange = (date: Dayjs | null) => {
    if (dayjs(date).isValid()) {
      formik.setFieldValue("dob", date);
    } else {
      formik.setFieldValue("dob", null);
    }
  };

  const handleSubmit = async () => {
    let body: BodyProps = {
      date_of_birth: "",
      first_name: "",
      last_name: "",
    };
    if (
      formik.values.firstName &&
      formik.values.lastName &&
      formik.values.dob
    ) {
      body = {
        first_name: formik.values.firstName,
        last_name: formik.values.lastName,
        date_of_birth: dayjs(formik.values.dob).format("YYYY-MM-DD"),
      };
    }

    const res = await updateUser(body);
    if (res.meta.requestStatus === "fulfilled") {
      setUser({
        firstName: res?.payload?.first_name,
        lastName: res?.payload?.last_name,
        dob: res?.payload?.date_of_birth,
        isLoading: false,
      });
      if (currentUser) {
        const retrievedUser = JSON.parse(currentUser);
        const newUser = {
          ...retrievedUser,
          firstName: res?.payload?.first_name,
          lastName: res?.payload?.last_name,
          dob: res?.payload?.date_of_birth,
          isLoading: false,
        };
        localStorage.setItem("currentUser", JSON.stringify(newUser));
      }
      setContentRender({ setProfilePhoto: true, signUp: false });
      // authState();
      setAlert({
        alert: {
          isVisible: true,
          message: `Profile registered Successfully`,
          type: "success",
        },
      });
    }
  };

  useEffect(() => {
    if (user.firstName) {
      formik.setFieldValue("firstName", user.firstName);
    }
    if (user.lastName) {
      formik.setFieldValue("lastName", user.lastName);
    }
    if (user.dob) {
      handleDateChange(dayjs(user?.dob));
    }
  }, [user]);

  return (
    <Container>
      <Content>
        <LogoWrapper>
          <Logo />
          <TitleWrapper>
            <Title>Welcome to rkbt</Title>
            <SubTitle>
              Create an account to create, share and join games
            </SubTitle>
          </TitleWrapper>
        </LogoWrapper>
        <Wrapper>
          <FormWrapper>
            <TextField
              disabled
              name={"email"}
              placeholder="Email address"
              value={formik.values.email}
              touched={formik.touched.email}
              errorMessage={formik.errors.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <TextField
              name={"firstName"}
              placeholder="First Name"
              value={formik.values.firstName}
              touched={formik.touched.firstName}
              errorMessage={formik.errors.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <TextField
              name={"lastName"}
              placeholder="Last Name"
              value={formik.values.lastName}
              touched={formik.touched.lastName}
              errorMessage={formik.errors.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <CalendarField
              label="Date Of Birth"
              onChange={handleDateChange}
              value={formik.values.dob}
              errorMessage={formik.errors.dob}
              name="dob"
            />
          </FormWrapper>
          <Button
            iscta
            textColor={theme.palette.grey[100]}
            color="secondary"
            isDisabled={!(formik.isValid && formik.dirty)}
            text={"Create an account"}
            type={"button"}
            onClick={() => {
              handleSubmit();
            }}
          />
        </Wrapper>
      </Content>
    </Container>
  );
};
const mapDispatchToProps = {
  setLoader: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setAlert: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setUser: homeActions.setUser,
  updateUser: profileActions.updateUser,
};

const connector = connect(undefined, mapDispatchToProps);
const SignUpRedux = connector(SignUp);

export { SignUpRedux as SignUp };
